export const AssignZonePickersResource = {
  name: "Assign Zone Pickers",
  path: "/user-management/assign-zone-pickers",
  access: ["read-assignZonePickers"],
};
